import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var AssetListItem = function AssetListItem() {
  return import('@/components/molecules/AssetListItem');
};
var LazyImage = function LazyImage() {
  return import('@/components/atoms/LazyImage');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var BuyMemoriaModal = function BuyMemoriaModal() {
  return import('@/components/organisms/BuyMemoriaModal');
};
export default {
  components: {
    PageHeader: PageHeader,
    AssetListItem: AssetListItem,
    LazyImage: LazyImage,
    RarityIcon: RarityIcon,
    BraveBurstListItem: function BraveBurstListItem() {
      return import('~/components/molecules/BraveBurstListItem');
    },
    BuyMemoriaModal: BuyMemoriaModal
  },
  data: function data() {
    return {
      memoriaMasters: [],
      selectedMemoria: {},
      isBuyMemoriaModalShown: false
    };
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    sortedMemorias: function sortedMemorias() {
      var memorias = this.$util.clone(this.memoriaMasters);
      memorias.sort(function (p, c) {
        if (p.memoriaType < c.memoriaType) return -1;
        if (p.memoriaType > c.memoriaType) return 1;
        return 0;
      });
      memorias.sort(function (p, c) {
        if (p.unitTypeList[0] < c.unitTypeList[0]) return -1;
        if (p.unitTypeList[0] > c.unitTypeList[0]) return 1;
        return 0;
      });
      memorias.sort(function (p, c) {
        if ((p.rarity || 1) < (c.rarity || 1)) return 1;
        if ((p.rarity || 1) > (c.rarity || 1)) return -1;
        return 0;
      });
      return memorias;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.isLoggedIn) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _this.memoriaMasters = _this.getBBsInfo(useMemoriaMaster().getMemoriaTypes.filter(function (memoria) {
              return memoria.memoriaPart == 3;
            }));
            _context.next = 5;
            return useConsumableStore().fetchConsumeMyItems();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    buy: function buy() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.$memoriaService.buyMemoria(_this2.selectedMemoria.memoriaType);
            case 3:
              _context2.next = 5;
              return useConsumableStore().fetchConsumeMyItems();
            case 5:
              _this2.isBuyMemoriaModalShown = false;
              _this2.$toast.success('Success.');
              _context2.next = 13;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
              _this2.$toast.error('Error.');
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }))();
    },
    getBBsInfo: function getBBsInfo(bbs) {
      return bbs.map(function (bb) {
        var bbTmp = useSkillMaster().getSkillById(bb.skillId);
        bb.name = bbTmp.name;
        bb.description = bbTmp.description;
        return bb;
      });
    },
    showBuyMemoriaModal: function showBuyMemoriaModal(memoria) {
      this.selectedMemoria = memoria;
      this.isBuyMemoriaModalShown = true;
    }
  }
};